/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.1
 */

import IWidgetVotingTranslation from '../../../types/pages/dashboard/widgetVoting';

const initTranslationWidgetVoting: IWidgetVotingTranslation = {
    btn: '',
    text: '',
    title: '',
    widgetTitle: '',
};

export default initTranslationWidgetVoting;
